import Vue from 'vue';
import "@babel/polyfill";
import './config.js';
import Layout from './layout.vue';
import router from './router';
import './config/';
import './global-components';
import store from "./store"
import { config } from "./util/mixins";

Vue.mixin(config);

window.VueInstance = new Vue({
    el: '#app',
    router,
    store,
    components: {
        Layout
    },
    template: '<Layout/>'
});
